import React from "react";
import {Utility} from "@renta-apps/athenaeum-toolkit";
import RentaTasksWizardPage from "../RentaTasksWizardPage";
import TaskMounter from "../../../models/server/TaskMounter";
import {DropdownWidget, TitleWidget} from "@renta-apps/athenaeum-react-components";
import GetEmployeesRequest from "@/models/server/requests/GetEmployeesRequest";
import Localizer from "@/localization/Localizer";
import {RentaTasksAction} from "@/pages/RentaTasks/RentaTasksController";

export interface IAssignMountersProps {
}

interface IAssignMountersState {
    mounters: TaskMounter[]
}

export default class AssignMounters extends RentaTasksWizardPage<IAssignMountersProps, IAssignMountersState> {

    state: IAssignMountersState = {
        mounters: []
    };

    private get mounters(): string[] {
        return this.wizard.mounters || [];
    }

    private async onAssignMounter(sender: DropdownWidget<TaskMounter>): Promise<void> {

        this.wizard.mounters = sender.selectedItems.map(item => item.user.id);
        this.saveContext();

        await this.reRenderAsync();
    }

    private get description(): string {
        return (this.mounters.length > 0)
            ? Utility.format(Localizer.rentaTasksAssignMounterDropdownWidgetMountersAssigned, this.mounters.length)
            : Localizer.rentaTasksAssignMounterDropdownWidgetAssignMounters;
    }

    protected getNoToggle(): boolean {
        return true;
    }

    public getManual(): string {
        return Localizer.assignMountersManual;
    }

    public async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        // When editing, the whole list is offered like on desktop, so a subcontractor mounter whose company is not
        // yet on the site can still be assigned - the server links the company to the contract. When creating, the
        // list stays narrowed to the site that was just picked. See RSW-40509.
        const editing: boolean = (this.wizard.action === RentaTasksAction.EditWorkOrder);

        const request: GetEmployeesRequest = (editing)
            ? new GetEmployeesRequest()
            : new GetEmployeesRequest(this.wizard.owner?.id);

        const mounters: TaskMounter[] = await this.postAsync("api/rentaTasks/getMountersData", request);

        await this.setState({ mounters });

        // Auto-select current user if they are a mounter and this is a new work order
        if (this.wizard.workOrder && this.wizard.workOrder.id === "" && this.isMounter) {
            const currentUserId = this.getUserId();
            const currentMounter = mounters.find(m => m.user.id === currentUserId);
            if (currentMounter && !this.wizard.mounters?.includes(currentUserId)) {
                this.wizard.mounters = [...(this.wizard.mounters || []), currentUserId];
                this.saveContext();
                await this.reRenderAsync();
            }
        }
    }

    public renderContent(): React.ReactNode {
        return (
            <React.Fragment>

                <TitleWidget wide model={this.title} />

                <DropdownWidget<TaskMounter> wide multiple autoGroupSelected expanded
                                             id="Mounters"
                                             disabled={this.isSalesPerson}
                                             icon={{name: "fas rocket"}}
                                             label={Localizer.addTaskModalMounters}
                                             description={this.description}
                                             items={this.state.mounters}
                                             selectedItems={this.mounters}
                                             onChange={async (sender) => await this.onAssignMounter(sender)}
                />

            </React.Fragment>
        );
    }
}